import { gql } from "graphql-tag";

export const GET_CATELOUGE = gql`
{
    download_catalogue {
      area{
          id
          value
      }
      category{
          id
          value
      }
      areacollections{
          area_id
          area_name
          categorycollection{
              category_id
              category_name
              categorydata{
                  url_key
                  title
                  image
                  pdf
              }
          }
      }
    }
  }
`;
export const CREATE_COMPARE_LIST = gql`
mutation ($productIds: [ID!]!) {
    createCompareList(
      input: {
        products: $productIds
      }
    ) {
      uid
      item_count
    }
  }
  `;

export const ADD_ITEM_IN_COMPARE_LIST = gql`
  mutation ($compareListUid: ID!, $productIds: [ID!]!) {
    addProductsToCompareList(
      input: {
        uid: $compareListUid
        products: $productIds
      }
    ) {
      uid
      item_count
    }
  }
  
    `;
export const DELETE_ITEM_FROM_COMPARE_LIST = gql`
mutation ($compareListUid: ID!, $productIds: [ID!]!) {
  removeProductsFromCompareList(
    input: {
      uid: $compareListUid
      products: $productIds
    }
  ) {
    uid
    item_count
    attributes {
      code
      label
    }
    items {
      uid
      product {
        sku
        name
        description {
          html
        }
      }
    }
  }
}
`;
export const GET_COMPARE_LIST = gql`
query ($compareListUid: ID!) {
  compareList(uid: $compareListUid) {
    uid
    item_count
    attributes {
      code
      label
    }
    items {
      uid
      product {
        id
        name
        sku
        url_key
        extraVariables{
            image_url
            product_url
            tile_size
            liquidation_sale
            stock
            plocation
            category_ids
           
            

            tile_design
            tile_type
            tile_area
            colors
            
          finish{
            label
            value
            url_key
        }
        type{
          label
          value
          url_key
      }
            colors
            rating_summary{
                rating_count
                avg_rating
                avg_percentage
            }
            sq_mt_price
            sq_ft_price
            discounted_price
            total_area_sq_ft
        }
        description {
            html
        }
    }
    }
  }
}

`;
export const GET_PROLOCATION =  gql`query P_location($pincode: Int!){
  p_location(pincode : $pincode){
    pincode
    attribute_name
    state
    value
  }
}`;